import { TypeOfUser } from '../helpers/Constants';

export type AiOnboardingProfessionalType =
  | 'pharmacist'
  | 'technician'
  | 'student';

export type AiOnboardingDocumentType =
  | 'profilePicture'
  | 'resume'
  | 'diplomaCertificate';

export type AiOnboardingRemoteDocumentType = Exclude<
AiOnboardingDocumentType,
'profilePicture'
>;

export interface IAiOnboardingSoftwareSelection {
  softwareId: string;
  expLevel: 1 | 2 | 3 | 4 | 5;
}

export interface IAiOnboardingProfileFields {
  role:
    | TypeOfUser.pharmacist
    | TypeOfUser.technician
    | TypeOfUser.student;
  preferdLanguage: string;
  firstName: string;
  lastName: string;
  professionalCapacityId: string;
  licenseNumber: string | null;
  graduationYear: number | null;
  yearsOfExperience: number | null;
  englishLevel: 0 | 1 | 2;
  frenchLevel: 0 | 1 | 2;
  otherLanguages: string;
  incorporated: boolean;
  isDSQKeyAvailable: boolean;
  isMethadonePrepKnowledge: boolean;
  isComfortDispillVerification: boolean;
  selectedSoftwares: IAiOnboardingSoftwareSelection[];
  selectedContactPreferences: string[];
  address: string;
  city: string;
  province: string;
  postalCode: string;
  phone: string;
  mobile: string;
  preferredWorkingDays: number[];
  preferredReplacementDuration: string;
  availabilityReminder: boolean;
  preferredDistanceRange: number | null;
  remoteRegion: boolean;
  latitude: number | null;
  longitude: number | null;
  diploma: string | null;
  instituteName: string | null;
  techGraduationYear: number | null;
  certificateFileName: string | null;
}

export type IAiOnboardingDetails = IAiOnboardingProfileFields;

export type IAiOnboardingDraft = Partial<IAiOnboardingProfileFields>;

export type IAiOnboardingFinalProfileFields = IAiOnboardingProfileFields & {
  signupRequestId: string;
};

export interface IAiOnboardingSnapshot {
  licenseVerified: boolean | null;
  nameVerified: boolean | null;
  onboardingDetails: IAiOnboardingDraft | null;
}

export const AI_ONBOARDING_INITIAL_SNAPSHOT: IAiOnboardingSnapshot = {
  licenseVerified: null,
  nameVerified: null,
  onboardingDetails: null,
};

export interface IVerifyAiOnboardingPharmacistLicenseParams {
  firstName: string;
  lastName: string;
  licenseNumber: string;
}

export interface IAiOnboardingPharmacistLicenseVerificationResult {
  success: boolean;
  licenseVerified: boolean;
  nameVerified: boolean;
}

export interface IUploadAiOnboardingDocumentParams {
  signupRequestId: string;
  documentType: AiOnboardingRemoteDocumentType;
  form: FormData;
}

export interface IAiOnboardingDocumentContent {
  content: string | null;
}
